<template>
    <v-card max-width="700" min-width="500" v-if="activeUser && Object.keys(activeUser).length > 0">
        <v-card-title
            >{{
                `${activeUser.first_name ? activeUser.first_name : "-"} ${
                    activeUser.last_name ? activeUser.last_name : ""
                }`
            }}
        </v-card-title>

        <v-card-text>
            <div class="subtitle-1">{{ "Email" | t }}: {{ activeUser.email ? activeUser.email : "-" }}</div>
            <div class="subtitle-1">
                {{ "Phone number" | t }}: {{ activeUser.phone_number ? activeUser.phone_number : "-" }}
            </div>
            <div class="subtitle-1">{{ "Locale" | t }}: {{ activeUser.locale }}</div>
        </v-card-text>

        <v-divider class="mx-4"></v-divider>

        <v-card-title>{{ activeCompany.name ? activeCompany.name : "" }}</v-card-title>

        <v-card-text>
            <div v-if="activeUser.company_role === 'owner'" class="subtitle-1">
                {{ "Role" | t }}: {{ activeUser.company_role ? t(activeUser.company_role) : "-" }}
            </div>
            <div class="subtitle-1">
                {{ "Legal type" | t }}: {{ activeCompany.legal_type ? t(activeCompany.legal_type) : "-" }}
            </div>
            <div class="subtitle-1">
                {{ "Identification code" | t }}:
                {{ activeCompany.identification_code ? activeCompany.identification_code : "-" }}
            </div>
            <div class="subtitle-1">
                {{ "EU vat number" | t }}:
                {{ activeCompany.eu_vat_number ? activeCompany.eu_vat_number : "-" }}
            </div>
            <div class="subtitle-1">{{ "Country" | t }}: {{ activeCompany.country ? activeCompany.country : "-" }}</div>
            <div class="subtitle-1">
                {{ "Homepage URL" | t }}: {{ activeCompany.client_url ? activeCompany.client_url : "-" }}
            </div>
            <div class="subtitle-1">
                {{ "Postback URL" | t }}: {{ activeCompany.postback_url ? activeCompany.postback_url : "-" }}
            </div>
        </v-card-text>

        <v-divider class="mx-4"></v-divider>
        <v-card-title>{{ "Company contact" | t }}</v-card-title>
        <v-card-text>
            <div class="subtitle-1">
                {{ "Email" | t }}:
                {{ activeCompany.contact_email ? activeCompany.contact_email : "-" }}
            </div>
            <div class="subtitle-1">
                {{ "Phone" | t }}:
                {{ activeCompany.contact_phone ? activeCompany.contact_phone : "-" }}
            </div>
            <div class="subtitle-1">
                {{ "Address" | t }}:
                {{ activeCompany.contact_address ? activeCompany.contact_address : "-" }}
            </div>
        </v-card-text>
        <v-card-actions>
            <v-spacer />
            <v-btn color="black" text @click="handleEditClick">
                {{ "Edit" | t }}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "user-and-company-card",
    computed: {
        ...mapState(["activeUser", "activeCompany"])
    },
    methods: {
        handleEditClick() {
            this.$router.push({ name: "user-and-company-edit" });
        }
    }
};
</script>

<style scoped></style>
